import {useSelector} from "react-redux";
import {useQuery} from "@tanstack/react-query";
import {LedgerBoardsApi} from "@devour/client";
import {IStore} from "@/redux/defaultStore";
import getConfig from "@/utils/getConfig";

/**
 * A board's prize ladder — which ranks pay, and what each place receives.
 *
 * Read rather than authored: `payingPlaces` comes from the tiers themselves, so
 * a surface saying "Top 20 win prizes" cannot drift from a board whose tiers
 * were changed to pay ten. Public, like the standings — what is on offer is the
 * reason to compete, so a logged-out visitor sees it too.
 *
 * No polling. A prize ladder changes when an operator edits the board, not
 * while someone is reading it, so this stays cached for the session.
 */
export function useGetBoardPrizes(ledgerBoardId?: string) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return useQuery({
        queryKey: ["ledger-prizes", ledgerBoardId],
        enabled: Boolean(ledgerBoardId),
        staleTime: Infinity,
        queryFn: async () => {
            if (!ledgerBoardId) return undefined;
            return new LedgerBoardsApi(getConfig(fullToken)).getLedgerBoardsBoardIdPrizes({boardId: ledgerBoardId});
        },
    });
}
